import { defineConfig } from '@sitecore-content-sdk/nextjs/config';

/**
 * @type {import('@sitecore-content-sdk/nextjs/config').SitecoreConfig}
 *
 * Central Sitecore configuration. `defineConfig` automatically reads the
 * following standard environment variables (no explicit mapping needed):
 *   SITECORE_EDGE_CONTEXT_ID  → api.edge.contextId
 *   SITECORE_EDGE_URL         → api.edge.edgeUrl
 *   SITECORE_API_HOST         → api.local.apiHost
 *   SITECORE_API_KEY          → api.local.apiKey
 *   SITECORE_SITE_NAME        → defaultSite
 *   DEFAULT_LANGUAGE          → defaultLanguage
 *
 * See: https://doc.sitecore.com/xmc/en/developers/content-sdk/the-sitecore-configuration-file.html
 */
export default defineConfig({
  // The current app uses JSS_EDITING_SECRET — map it explicitly so existing
  // environment variables continue to work without renaming.
  // Once convenient, rename the env var to SITECORE_EDITING_SECRET and remove this line.
  editingSecret: process.env.SITECORE_EDITING_SECRET || process.env.JSS_EDITING_SECRET,

  // Manual mapping for backwards compatibility with old environment variables
  defaultSite:
    process.env.SITECORE_SITE_NAME ||
    process.env.NEXT_PUBLIC_DEFAULT_SITE_NAME ||
    process.env.DEFAULT_SITE_NAME,

  redirects: {
    enabled: true,
    // Keep in sync with i18n.locales in next.config.js
    locales: ['en-US', 'es-MX', 'fr-CA', 'ar-AE'],
  },

  // Skip codegen on Vercel (pre-built artifacts are already present)
  disableCodeGeneration: process.env.VERCEL === '1',
});
